import { TProfileEdit } from "@utils/Interfaces";
import TextArea from "antd/es/input/TextArea";

const AboutEdit: React.FC<TProfileEdit> = ({ data, handleChangeValue }) => {
  return (
    <div className="AboutEdit">
      <div className="form-group">
        <div className="title">About Yourself</div>
        <TextArea
          value={data.about || ""}
          onChange={(e) => handleChangeValue(e.target.value, "about")}
          className="about-edit"
          rows={10}
        />
      </div>
    </div>
  );
};


export default AboutEdit;